export const ALL_COLORS = [
	'#647a46',
	'#797702',
	'#447C8D',
	'#CC4A33',
	'#5D72B1',
	'#BF5708',
	'#408271',
	'#247DA3'
]

export const COLORS_IN_ORDER = [
	'#647a46',
	'#797702',
	'#447C8D',
	'#CC4A33',
	'#647a46',
	'#797702',
	'#5D72B1',
	'#BF5708',
	'#408271',
	'#247DA3',
	'#5D72B1',
	'#BF5708',
	'#247DA3',
	'#CC4A33',
	'#5D72B1',
	'#797702',
	'#CC4A33',
	'#408271'
]

export const DEFAULT_COLOR = '#CC4A33'
